<tec-tile icon="icon-user" [title]="'IDENTITIES.DETAIL.IDENTITY' | translate">
    <!-- Slot `actions` siempre proyectado; permiso/visibilidad dentro. -->
    <ng-container actions>
        @if (canShowEdit) {
            <tec-button-icon
                icon="icon-edit"
                size="sm"
                [tooltip]="'BUTTON.EDIT' | translate"
                (clickEvent)="onEditClick()"
            />
        }
        <app-developer-curl-button [path]="curlPath" [titleKey]="curlTitleKey" />
    </ng-container>

    @if (hasData) {
        <tec-info-group [label]="'IDENTITIES.DETAIL.NAME' | translate">
            <span>{{ fullName || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.NUM_DOCUMENT' | translate">
            <span>
                {{ identifier || ('GENERAL.NOT_AVAILABLE' | translate) }}
            </span>
            <ng-content select="[identityIdentifierActions]" />
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.TYPE_DOCUMENT' | translate">
            <span>{{ masterService.getDocumentTypeLabel(documentType) }}</span>
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.EXPIRY_DATE' | translate">
            @if (expirationDate) {
                <tec-icon name="icon-calendar" />
            }
            <span>
                {{ (expirationDate | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}
            </span>
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.BIRTH_DATE' | translate">
            @if (birthDate) {
                <tec-icon name="icon-calendar" />
            }
            <span>
                {{ (birthDate | safeDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}
            </span>
            @if (ageYears !== null && ageYears !== undefined) {
                <tec-tag [status]="ageYears >= 18 ? 'success' : 'warning'">
                    {{ 'IDENTITIES.DETAIL.YEARS' | translate: { years_old: ageYears } }}
                </tec-tag>
            }
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.GENDER' | translate">
            <span>{{
                masterService.hasTranslation('MASTER.GENDERS.' + gender)
                    ? ('MASTER.GENDERS.' + gender | translate)
                    : ('GENERAL.NOT_AVAILABLE' | translate)
            }}</span>
        </tec-info-group>
        <tec-info-group [label]="'IDENTITIES.DETAIL.NACIONALITY' | translate">
            <span>
                {{
                    masterService.hasTranslation('MASTER.COUNTRIES.' + nationality)
                        ? ('MASTER.COUNTRIES.' + nationality | translate)
                        : (nationality ?? 'GENERAL.NO_INFO' | translate)
                }}
            </span>
        </tec-info-group>

        <ng-content select="[identityFooter]" />
        <ng-content select="[identityAddress]" />
    } @else {
        <tec-empty-state
            [title]="'GENERAL.NO_DATA' | translate"
            [size]="'default'"
            [type]="'empty'"
        />
    }
</tec-tile>
